module.exports = __webpack_public_path__ + "static/media/help-disk-help.9d40bf3c.svg";